<div class="card mb-4">
  <div class="card-body">
    <ms-sent-email-list-table
      [filter]="communicationHistoryFilter"
      [orderByInput]="orderBy"
      [viewLocation]="SentEmailListViewLocations.MemberProfilePage"
      (orderByChanged)="onOrderByChanged($event)">
    </ms-sent-email-list-table>
  </div>
</div>
